import React, { useState } from 'react';
import Container from '../layout/Container';
import Button from '../ui/Button';
import { colors, font } from '../../lib/tokens';

const EMAIL = 'info@katlacode.ai';

// The address, plus a copy button for visitors whose browser has no mail app
// wired to mailto: links.
function EmailLine() {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard blocked: the address is printed right beside the button,
      // so the visitor can still select it by hand.
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        fontFamily: font.mono,
        fontSize: 12,
        letterSpacing: 0.4,
      }}
    >
      <a href={`mailto:${EMAIL}`} className="kc-news-link" style={{ color: colors.ink2 }}>
        {EMAIL}
      </a>
      <span aria-hidden style={{ width: 1, height: 12, background: colors.hair }} />
      <button
        type="button"
        onClick={copy}
        className="kc-news-copy"
        style={{
          ...(copied ? { color: colors.blue } : null),
          background: 'transparent',
          border: 0,
          padding: 0,
          cursor: 'pointer',
          font: 'inherit',
          fontSize: 11,
          letterSpacing: 1,
          textTransform: 'uppercase',
        }}
      >
        <span aria-live="polite">
          {copied ? <span className="kc-pop">Copied</span> : 'Copy'}
        </span>
      </button>
    </div>
  );
}

export default function CtaSection() {
  return (
    <section
      className="kc-section"
      style={{
        background: colors.bg,
        borderTop: `1px solid ${colors.hair}`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Peak silhouette standing on the footer's edge like a horizon, in the
          open space between the heading and the button */}
      <svg
        data-draw
        className="hidden md:block kc-draw"
        width={420}
        height={300}
        viewBox="0 0 520 372"
        aria-hidden
        style={{
          position: 'absolute',
          left: '50%',
          bottom: 0,
          opacity: 0.07,
          pointerEvents: 'none',
          '--kc-draw-dur': '1800ms',
          '--kc-draw-d': '200ms',
        } as React.CSSProperties}
      >
        <path d="M20 372L260 12l240 360" pathLength={1} fill="none" stroke={colors.ink} strokeWidth={1.4} />
        <path d="M130 372L260 180l130 192" pathLength={1} fill="none" stroke={colors.ink} strokeWidth={1} />
      </svg>
      <Container>
        <div
          data-reveal
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 md:gap-12"
          style={{ position: 'relative', zIndex: 1 }}
        >
          <h2
            className="kc-display text-balance"
            style={{
              fontFamily: font.sans,
              fontSize: 'clamp(36px, 5vw, 64px)',
              fontWeight: 500,
              lineHeight: 1,
              letterSpacing: '-0.036em',
              color: colors.ink,
              margin: 0,
              maxWidth: 720,
            }}
          >
            See KatlaCode inside
            {' '}<br />
            your hospital’s EHR.
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 16, flexShrink: 0 }}>
            <Button variant="primary" size="lg" href={`mailto:${EMAIL}`}>
              Contact us
            </Button>
            <EmailLine />
          </div>
        </div>
      </Container>
    </section>
  );
}
